import React from "react";
import VisitBlocksListWrapper from "./VisitBlocksListWrapper";
import { convertDateToSODTimestamp, getDateString } from "../../../../utils/dateutils";
import FrequencyString from "./FrequencyString";

const Frequency = ({ careplan }) => {
  const startDate = careplan?.startDate;
  const currentDate = convertDateToSODTimestamp();

  return (
    <div className="patient-details-card">
      <VisitBlocksListWrapper careplan={careplan} />
      
      <span>
        {startDate && currentDate <= startDate && "Start Date: " + getDateString(startDate)}
      </span>
      <FrequencyString careplan={careplan} />
    </div>
  );
};

export default Frequency;
